<div
  :id="isMobile ? offcanvas_id : null"
  :class="isMobile ? 'offcanvas offcanvas-start d-lg-none' : ['client-sidebar', 'admin-sidebar', { close: isClosed }]"
  :tabindex="isMobile ? '-1' : null"
  :aria-labelledby="isMobile ? `${offcanvas_id}Label` : null"
  class="sidebar-shell"
>
  <div v-if="isMobile" class="offcanvas-header p-3">
    <button
      type="button"
      class="btn-close text-reset ms-auto"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>

  <div
    :class="[
      'client-sidebar',
      'admin-sidebar',
      'd-flex',
      'flex-column',
      'justify-content-between',
      'bg-white',
      'position-relative',
      isMobile ? 'offcanvas-body p-0' : '',
      { close: isClosed, 'min-vh-100 mt-2 rounded-end': !isMobile, 'h-100 w-100': isMobile }
    ]"
  >
  <button v-if="!isMobile && !isClosed" class="btn btn-link text-dark position-absolute top-0 end-0 mb-2 p-0" @click="isClosed = true" aria-label="Close sidebar">
    <i class="bi bi-list fs-6"></i>
  </button>

  <button v-else-if="!isMobile" class="btn btn-link text-dark position-absolute top-0 end-0 mt-2 p-0" @click="isClosed = false" aria-label="Open sidebar">
    <i class="bi bi-chevron-double-right fs-6"></i>
  </button>
<div class="d-flex flex-column flex-grow-1 min-h-0 w-100 sidebar-menu-frame">
  <div ref="sidebarScrollArea" class="flex-grow-1 overflow-auto scrollarea sidebar-scroll-area min-h-0">
      
      <li class="nav-item my-0 mt-2 w-100">
        <router-link to="/dashboard" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Dashboard' : ''">
          <i class="bi bi-grid-fill fs-6"></i>
          <div class="text-xxs fw-bold" v-if="!isClosed">Dashboard</div>
        </router-link>
      </li>

      <hr class="mx-3 my-2 text-muted w-100" v-if="!isClosed" />

    <div class="admin-sidebar-section" :class="{ 'is-open': is_sidebar_section_open('user_management') }">
      <li class="nav-item px-3 mb-1 text-uppercase text-muted fw-bold admin-sidebar-section-title" v-if="!isClosed">
        <button type="button" class="admin-sidebar-section-toggle" @click="toggle_sidebar_section('user_management')">
          <span>User Management</span>
          <i class="bi bi-chevron-down admin-sidebar-section-chevron"></i>
        </button>
      </li>

      <div class="admin-sidebar-section-body">
      <li class="nav-item my-0 w-100">
        <router-link to="/create_user" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Users' : ''">
          <i class="bi bi-person-badge fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Users</div>
        </router-link>
      </li>

      <li class="nav-item my-0 w-100">
        <router-link to="/view_business_dashboard" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Business Profiles' : ''">
          <i class="bi bi-briefcase fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Business Profiles</div>
        </router-link>
      </li>
      <hr class="mx-3 my-2 text-muted w-100" v-if="!isClosed" />
      </div>
    </div>

    <div v-if="client_features.show_portals" class="admin-sidebar-section" :class="{ 'is-open': is_sidebar_section_open('portal_management') }">

      <li class="nav-item px-3 mb-1 text-uppercase text-muted fw-bold admin-sidebar-section-title" v-if="!isClosed">
        <button type="button" class="admin-sidebar-section-toggle" @click="toggle_sidebar_section('portal_management')">
          <span v-if="school_domain">Grades Management</span>
          <span v-else>Portal Management</span>
          <i class="bi bi-chevron-down admin-sidebar-section-chevron"></i>
        </button>
      </li>

      <div class="admin-sidebar-section-body">
      <li class="nav-item my-0 w-100">
        <router-link to="/create_portal" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? (!cbo_domain ? 'Manage Portals' : 'Manage Membership') : ''">
          <i class="bx bx-command fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">
            <span v-if="school_domain">Manage Grades</span>
            <span v-else-if="cbo_domain">Manage Chapters</span>
            <span v-else>Manage Portals</span></div>
        </router-link>
      </li>

      <li class="nav-item my-0 w-100">
        <router-link to="/create_report" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Reports' : ''">
          <i class="bi bi-journal-text fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Feeds</div>
        </router-link>
      </li>

      <li class="nav-item my-0 w-100" v-if="!cbo_domain">
        <router-link to="/create_group" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Groups' : ''">
          <i class="bi bi-people fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">
            <span v-if="school_domain">Manage Classes</span>
            <span v-else>Manage Groups</span>
          </div>
        </router-link>
      </li>
      
      <hr class="mx-3 my-2 text-muted w-100" v-if="!isClosed" />
      </div>
    </div>


    <div v-if="client_features.show_events" class="admin-sidebar-section" :class="{ 'is-open': is_sidebar_section_open('events_management') }">
      <li class="nav-item px-3 mb-1 text-uppercase text-muted fw-bold admin-sidebar-section-title" v-if="!isClosed">
        <button type="button" class="admin-sidebar-section-toggle" @click="toggle_sidebar_section('events_management')">
          <span>Events Management</span>
          <i class="bi bi-chevron-down admin-sidebar-section-chevron"></i>
        </button>
      </li>
      <div class="admin-sidebar-section-body">
      <li class="nav-item my-0 w-100">
        <router-link to="/events" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Events' : ''">
          <i class="bi bi-calendar2-event fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Events</div>
        </router-link>
      </li>

      <li class="nav-item my-0 w-100">
        <router-link to="/manage_rsvps" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Events' : ''">
          <i class="bi bi-calendar2-event fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage RSVPs</div>
        </router-link>
      </li>

      <hr class="mx-3 my-2 text-muted w-100" v-if="!isClosed" />
      </div>
    </div>

      <div v-if="client_features.show_membership" class="admin-sidebar-section" :class="{ 'is-open': is_sidebar_section_open('membership_management') }">
      <li class="nav-item px-3 mb-1 text-uppercase text-muted fw-bold admin-sidebar-section-title" v-if="!isClosed">
        <button type="button" class="admin-sidebar-section-toggle" @click="toggle_sidebar_section('membership_management')">
          <span>Membership Management</span>
          <i class="bi bi-chevron-down admin-sidebar-section-chevron"></i>
        </button>
      </li>

      <div class="admin-sidebar-section-body">
      <li class="nav-item my-0 w-100">
        <a
          href="/create_membership"
          :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']"
          :title="isClosed ? 'Create Membership' : ''"
        >
          <i class="bi bi-chat-square-text fs-6"></i>

          <div class="text-xxs" v-if="!isClosed">Manage Membership</div>
        </a>
      </li>

      <hr class="mx-3 my-2 text-muted w-100" v-if="!isClosed" />
      </div>
    </div>

    <div v-if="client_features.show_donations" class="admin-sidebar-section" :class="{ 'is-open': is_sidebar_section_open('donation_management') }">
      <li class="nav-item px-3 mb-1 text-uppercase text-muted fw-bold admin-sidebar-section-title" v-if="!isClosed">
        <button type="button" class="admin-sidebar-section-toggle" @click="toggle_sidebar_section('donation_management')">
          <span>Donation Management</span>
          <i class="bi bi-chevron-down admin-sidebar-section-chevron"></i>
        </button>
      </li>

      <div class="admin-sidebar-section-body">
      <li class="nav-item my-0 w-100">
        <a
          href="/donation_campaigns_dashboard"
          :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']"
          :title="isClosed ? 'Donation Campaigns' : ''"
        >
          <i class="bi bi-cash-coin fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Donation Campaigns</div>
        </a>
      </li>

      <hr class="mx-3 my-2 text-muted w-100" v-if="!isClosed" />
      </div>
    </div>

    <div v-if="client_features.show_marketplace" class="admin-sidebar-section" :class="{ 'is-open': is_sidebar_section_open('marketplace_management') }">
      <li class="nav-item px-3 mb-1 text-uppercase text-muted fw-bold admin-sidebar-section-title" v-if="!isClosed">
        <button type="button" class="admin-sidebar-section-toggle" @click="toggle_sidebar_section('marketplace_management')">
          <span>Marketplace Management</span>
          <i class="bi bi-chevron-down admin-sidebar-section-chevron"></i>
        </button>
      </li>

      <div class="admin-sidebar-section-body">
      <li class="nav-item my-0 w-100">
        <router-link to="/manage_catalogue" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Catalogue' : ''">
          <i class="bi bi-box-seam fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Products</div>
        </router-link>
      </li>
      <li class="nav-item my-0 w-100">
        <router-link to="/manage_services" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Services' : ''">
          <i class="bi bi-tools fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Services</div>
        </router-link>
      </li>
      <li class="nav-item my-0 w-100">
        <router-link to="/manage_promotions" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Promotions' : ''">
          <i class="bi bi-megaphone fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Promotions</div>
        </router-link>
      </li>
      <hr class="mx-3 my-2 text-muted w-100" v-if="!isClosed" />
      </div>

    </div>


<div class="admin-sidebar-section" :class="{ 'is-open': is_sidebar_section_open('form_management') }">

      <li class="nav-item px-3 mb-1 text-uppercase text-muted fw-bold admin-sidebar-section-title" v-if="!isClosed">
        <button type="button" class="admin-sidebar-section-toggle" @click="toggle_sidebar_section('form_management')">
          <span>Form Management</span>
          <i class="bi bi-chevron-down admin-sidebar-section-chevron"></i>
        </button>
      </li>

      <div class="admin-sidebar-section-body">
      <li class="nav-item my-0 w-100">
        <router-link to="/create_form" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Forms' : ''">
          <i class="bi bi-file-earmark-text fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Forms</div>
        </router-link>
      </li>

      <li class="nav-item my-0 w-100">
        <router-link to="/manage_sections" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Sections' : ''">
          <i class="bi bi-list-task fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Sections</div>
        </router-link>
      </li>

      <li class="nav-item my-0 w-100">
        <router-link to="/manage_questions" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Questions' : ''">
          <i class="bi bi-question-square fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Questions</div>
        </router-link>
      </li>
      <li class="nav-item my-0 w-100 d-none">
        <router-link to="/create_profile_tabs" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Profile Tabs' : ''">
          <i class="bi bi-file-earmark-text fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Profile Tabs</div>
        </router-link>
      </li>
      <hr class="mx-3 my-2 text-muted w-100" v-if="!isClosed" />
      </div>

</div>

<div class="admin-sidebar-section" :class="{ 'is-open': is_sidebar_section_open('community_management') }">
      <li class="nav-item px-3 mb-1 text-uppercase text-muted fw-bold admin-sidebar-section-title" v-if="!isClosed">
        <button type="button" class="admin-sidebar-section-toggle" @click="toggle_sidebar_section('community_management')">
          <span>Community Management</span>
          <i class="bi bi-chevron-down admin-sidebar-section-chevron"></i>
        </button>
      </li>


      <div class="admin-sidebar-section-body">
      <li class="nav-item my-0 w-100">
        <router-link to="/create_assets" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Assets' : ''">
          <i class="bi bi-box-seam fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Assets</div>
        </router-link>
      </li>

      <li v-if="client_features.show_your_voice" class="nav-item my-0 w-100">
        <router-link to="/create_survey" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Surveys' : ''">
          <i class="bi bi-clipboard-check fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Surveys</div>
        </router-link>
      </li>

      <li v-if="client_features.show_your_voice" class="nav-item my-0 w-100">
        <router-link to="/create_discussion" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Discussions' : ''">
          <i class="bi bi-chat-left-text small"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Discussions</div>
        </router-link>
      </li>

      <li v-if="client_features.show_your_voice" class="nav-item my-0 w-100">
        <router-link to="/create_polls" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Polls' : ''">
          <i class="bi bi-bar-chart-line fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Polls</div>
        </router-link>
      </li>
      <hr class="mx-3 my-2 text-muted w-100" v-if="!isClosed" />
      </div>

</div>
<div v-if="client_features.show_incident" class="admin-sidebar-section" :class="{ 'is-open': is_sidebar_section_open('incident_management') }">
      <li class="nav-item px-3 mb-1 text-uppercase text-muted fw-bold admin-sidebar-section-title" v-if="!isClosed">
        <button type="button" class="admin-sidebar-section-toggle" @click="toggle_sidebar_section('incident_management')">
          <span>Incident Reporting Management</span>
          <i class="bi bi-chevron-down admin-sidebar-section-chevron"></i>
        </button>
      </li>
      <div class="admin-sidebar-section-body">
        <li class="nav-item my-0 w-100">
        <router-link to="/manage_incident_types" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Incident Types' : ''">
          <i class="bi bi-shield-exclamation fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Incident Types</div>
        </router-link>
      </li>
        <li class="nav-item my-0 w-100">
        <router-link to="/manage_incidents" :class="['nav-link d-flex align-items-center py-2 lh-sm w-100 rounded text-decoration-none text-dark', isClosed ? 'justify-content-center px-2' : 'gap-2 px-3']" active-class="bg-primary text-white" exact-active-class="bg-primary text-white" :title="isClosed ? 'Manage Incidents' : ''">
          <i class="bi bi-exclamation-triangle fs-6"></i>
          <div class="text-xxs" v-if="!isClosed">Manage Incidents</div>
        </router-link>
      </li>
      </div>

    </div>

</div>

 <div class="d-flex justify-content-start flex-shrink-0 p-3 sidebar-logout-area">
  <div 
    @click="log_out" 
    class="d-flex align-items-center gap-2 pointer-link logout-item pointer"
  >
    <i class='bx bx-log-out-circle fs-4'></i>
    <span class="fw-bold text-xxs">Logout</span>
  </div>
</div>

</div>
</div>
</div>
